export const authEndpoints = {
  LOGIN: "/api/v1/auth/login",
  REGISTER: "/api/v1/auth/signup",
  FORGOTPASS: "/api/v1/auth/forgot-password",
  RESETPASS: "/api/v1/auth/reset-password",
};

export const albumEndpoints = {
  CHECK_ACCESS_LINK: "/api/v1/check-access-link",
  CREATE_ALBUM: "/api/v1/albums",
  GET_ALBUMS: "/api/v1/albums",
  DELETE_ALBUM: "/api/v1/albums",
  EDIT_ALBUM: (id: string | number) => `/api/v1/albums/${id}`,
  GET_ALBUM_SYNC: (id: string) => `/api/v1/albums/${id}/sync`,
  CHECK_PASS_ALBUM: "/api/v1/client/albums",
  GET_ALBUM_BASIC: (id: string) => `/api/v1/client/albums/${id}/basic`,
  GET_ALBUM_PUBLIC: (id: string) => `/api/v1/client/albums/${id}/public`,
  // CHECK_FOLDER_WRITE: (id: string) => `/api/v1/albums/${id}/check-folder-writeable`,
  CHECK_DRIVE_COPY: "api/v1/albums-check-copy",
  COPY_DRIVE_TO_FOLDER: (id: string) => `/api/v1/albums/${id}/copy`,
  LOCK: (id: string) => `/api/v1/albums/${id}/lock`,
  CHANGE_THUMBNAIL: (id: string) => `/api/v1/albums/${id}/change-thumbnail`,
};

export const userEndpoint = {
  PROFILE: "api/v1/profile",
  SETTING: "api/v1/update-user-setting",
  CHECK_DOMAIN: "api/v1/check-domain",
  NOTIFICATION: "api/v1/notifications",
  MARK_ALL_AS_READ: "api/v1/notifications/view-all",
  MARK_AS_READ: (id: number) => `api/v1/notifications/view/${id}`,
};

export const fileEndpoint = {
  RECOMMEND: (id: string | number) => `/api/v1/files/${id}/recommend`,
  LIKED: (id: string | number) => `/api/v1/files/${id}/like`,
  COMMENTED: (id: string | number) => `/api/v1/files/${id}/comment`,
  TAG: (id: string | number) => `/api/v1/files/${id}/tag`,
};

export const paymentEndpoint = {
  CREATE_SUBCRIPTION: "/api/v1/subscriptions",
  PAYMENT_PAYPAL_CREATE: "/api/v1/payment/paypal/create",
  PAYMENT_PAYPAL_CHECK: "/api/v1/payment/paypal/verify",
  PAYMENT_NGAN_LUONG_CREATE: "/api/v1/payment/nganluong/create",
  PAYMENT_NGAN_LUONG_CHECK: "/api/v1/payment/nganluong/verify",
  PAYMENT_SEPAY_CREATE: "/api/v1/payment/sepay/create",
  PAYMENT_SEPAY_CHECK: "/api/v1/payment/sepay/verify",
  MEMBERSHIP_PLANS: "/api/v1/membership-plans",
  CHECK_DISCOUNT: "/api/v1/discounts",
  UPGRADE_PACKAGE: "/api/v1/subscriptions/calculate-upgrade",
};

export const setupWebEndpoint = {
  CREATE: "/api/v1/website",
  ACTIVE: "/api/v1/website/toggle",
};

export const commonEndpoint = {
  UPLOAD_PHOTO: "/api/v1/upload/image",
};

export const staticPage = {
  DETAIL: (path: string) => `api/v1/static-page/${path}`,
};

export const referralEndpoint = {
  DASHBOARD: "/api/v1/referrals/dashboard",
  GET_CODE: "/api/v1/referrals/code",
  UPDATE_CODE: "/api/v1/referrals/code",
  HISTORY: "/api/v1/referrals/history",
  ACTIVE_REWARDS: "/api/v1/referrals/rewards/active",
};
